import api from './client';
import { Project, Schedule } from '../types/project';

interface ProjectContext {
  org: {
    id: string;
    name: string;
  } | null;
  project: Project | null;
  schedule: Schedule | null;
  roles: string[];
  permissions: string[];
}

// Get the current project context
export const getProjectContext = async (): Promise<ProjectContext> => {
  try {
    const response = await api.get('/context');
    return response.data;
  } catch (error) {
    console.error('Error fetching project context:', error);
    throw error;
  }
};

// Set the current project
export const setCurrentProject = async (projectId: string): Promise<void> => {
  try {
    await api.post('/context/project', { projectId });
  } catch (error) {
    console.error('Error setting current project:', error);
    throw error;
  }
};

// Set the current schedule
export const setCurrentSchedule = async (scheduleId: string): Promise<void> => {
  try {
    await api.post('/context/schedule', { scheduleId });
  } catch (error) {
    console.error('Error setting current schedule:', error);
    throw error;
  }
};

// Set the current organization
export const setCurrentOrganization = async (orgId: string): Promise<void> => {
  try {
    await api.post('/context/organization', { orgId });
  } catch (error) {
    console.error('Error setting current organization:', error);
    throw error;
  }
};

// Clear the project context
export const clearProjectContext = async (): Promise<void> => {
  try {
    await api.delete('/context');
  } catch (error) {
    console.error('Error clearing project context:', error);
    throw error;
  }
}; 